import useLocalStorage from '@rehooks/local-storage';
import { ZuoraRevenueStorageKeys } from './useRevenueNavigation';
import { RevenueIdentifyingProps } from '../types';

// Capture Revenue Identity properties passed via Local Storage
export const useRevenueIdentity = (): RevenueIdentifyingProps => {
  const [readyToIdentify] = useLocalStorage('ZNav.RevenueInitQualtrics');

  const [revenueTenantId] = useLocalStorage(ZuoraRevenueStorageKeys.TenantId);
  const [revenueUserRole] = useLocalStorage(ZuoraRevenueStorageKeys.UserRole);
  const [revenueFirstName] = useLocalStorage(ZuoraRevenueStorageKeys.FirstName);
  const [revenueLastName] = useLocalStorage(ZuoraRevenueStorageKeys.LastName);
  const [revenueUserStatus] = useLocalStorage(
    ZuoraRevenueStorageKeys.UserStatus,
  );
  const [revenueEmail] = useLocalStorage(ZuoraRevenueStorageKeys.Email);
  const [revenueUserName] = useLocalStorage(ZuoraRevenueStorageKeys.UserName);
  const [revenueTenantName] = useLocalStorage(
    ZuoraRevenueStorageKeys.TenantName,
  );
  const [revenueUserID] = useLocalStorage(ZuoraRevenueStorageKeys.UserID);
  const [revenueUserLanguage] = useLocalStorage(
    ZuoraRevenueStorageKeys.UserLanguage,
  );

  // Language drives i18n and must be available as soon as Revenue writes
  // ZRevenue_UserLanguage. Qualtrics identifying props still wait for the
  // RevenueInitQualtrics handshake so tracking does not fire early.
  if (!readyToIdentify) {
    return {
      ...({} as RevenueIdentifyingProps),
      revenueUserLanguage,
    };
  }

  return {
    revenueTenantId,
    revenueUserRole,
    revenueFirstName,
    revenueLastName,
    revenueUserStatus,
    revenueEmail,
    revenueUserName,
    revenueTenantName,
    revenueUserID,
    revenueUserLanguage,
  };
};
